<ziro-loading-block id="loading-primary-extension" [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <div class="col-12 pb-5">
    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <ziro-directory-number-dn-did-selector-form
        (ziroFormsUpdate$)="onFormUpdate($event, 'DN_DID_SELECTOR_FORM')"
        [dialPlanGroups]="dialPlanGroups"
        [initialDialPlanGroupId]="initialDialPlanGroupId"
        [initialExtension]="initialDnRef?.extension"
        [entity]="dnDidSelectorFormEntity"
        [isZpmSyncWarningPresent]="isZpmSyncWarningPresent"
      ></ziro-directory-number-dn-did-selector-form>
      @if (
        dnDidSelectorFormEntity.dialPlanGroupId &&
        dnDidSelectorFormEntity.directoryNumber.extension &&
        !isFieldConfigsLoaded
      ) {
        <ziro-loading-block data-automation="directory-number-forms-loading-block"></ziro-loading-block>
      }
      @if (
        dnDidSelectorFormEntity.dialPlanGroupId &&
        dnDidSelectorFormEntity.directoryNumber.extension &&
        isFieldConfigsLoaded
      ) {
        <div data-automation="directory-number-forms">
          @if (isLdapUser() && isPrimaryEndUser) {
            <div>
              <ziro-directory-number-ldap-details-form
                [fieldConfig]="ldapFieldConfig"
                [entity]="dnLdapDetailsFormEntity"
                (ziroFormsUpdate$)="onFormUpdate($event, 'LDAP_DETAILS_FORM')"
              ></ziro-directory-number-ldap-details-form>
            </div>
          }
          <ziro-directory-number-details-form
            [fieldConfig]="dnDetailsFieldConfig"
            [entity]="dnDetailsFormEntity"
            (ziroFormsUpdate$)="onFormUpdate($event, 'DN_DETAILS_FORM')"
          ></ziro-directory-number-details-form>
          @if (dnDidSelectorFormEntity.translationPattern.pattern) {
            <div>
              <ziro-directory-number-did-details
                [fieldConfig]="didDetailsFieldConfig"
                [entity]="didDetailsFormEntity"
                (ziroFormsUpdate$)="onFormUpdate($event, 'DN_DID_DETAILS_FORM')"
              ></ziro-directory-number-did-details>
            </div>
          }
          <ziro-directory-number-ils-details-form
            [entity]="dnIlsDetailsFormEntity"
            [fieldConfigs]="dnIlsDetailsFieldConfig"
            (ziroFormsUpdate$)="onFormUpdate($event, 'DN_ILS_DETAILS_FORM')"
          ></ziro-directory-number-ils-details-form>
          @if (!isPublicPhone && hasUccxSettings) {
            <div>
              <ziro-directory-number-agent-extension-form
                [entity]="dnAgentExtFormEntity"
                (ziroFormsUpdate$)="onFormUpdate($event, 'DN_AGENT_EXT_FORM')"
                [dnExtension]="dnDidSelectorFormEntity.directoryNumber.extension"
              ></ziro-directory-number-agent-extension-form>
            </div>
          }
          <ziro-directory-number-call-forward-form
            [fieldConfig]="dnCallForwardFieldConfig"
            [entity]="dnCallForwardFormEntity"
            (ziroFormsUpdate$)="onFormUpdate($event, 'DN_CALL_FORWARD_FORM')"
            [hasVoicemail]="!!voicemailForExtension.length"
            [isUnityServerConfigured]="isUnityServerConfigured"
            [hideWarning]="initialDirectoryNumber && initialVoicemailRef && !voicemailForExtension.length"
          ></ziro-directory-number-call-forward-form>
        </div>
      }
    </ziro-collapsible-section-card>
  </div>
}
